<div class="dialog-wrapper">
  <h2 mat-dialog-title>
    {{
      (isEditing
        ? "brand.campaign.categoryDialog.editCategory"
        : "brand.campaign.categoryDialog.newCategory"
      ) | translate
    }}
  </h2>
  <mat-dialog-content>
    <div>
      <mat-form-field class="fieldset">
        <mat-label>{{
          "brand.campaign.categoryDialog.categoryName" | translate
        }}</mat-label>
        <input
          matInput
          [(ngModel)]="category.title"
          name="category_name"
          type="text"
          required
        />
        <mat-error class="campaign_name-error">
          {{ "brand.campaign.categoryDialog.nameRequired" | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="fieldset">
        <mat-label>{{
          "brand.campaign.categoryDialog.categoryDescription" | translate
        }}</mat-label>
        <input
          matInput
          [(ngModel)]="category.subtitle"
          name="category_description"
          type="text"
        />
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div>
      <button
        *ngIf="isEditing"
        class="btn btn--transparent btn--delete"
        (click)="onActionDeleteCategory()"
      >
        <span *ngIf="!removing">{{ "shared.remove" | translate }}</span>
        <span *ngIf="removing">{{ "shared.removing" | translate }}</span>
      </button>
    </div>
    <div>
      <button
        class="btn btn--transparent"
        [mat-dialog-close]=""
        [disabled]="saving"
      >
        {{ "shared.cancel" | translate }}
      </button>
      <button
        *ngIf="!isEditing"
        class="btn btn--primary"
        (click)="onActionCreateCategory()"
        [disabled]="saving || !category.title"
      >
        <span *ngIf="!saving">{{ "shared.continue" | translate }}</span>
        <span *ngIf="saving">{{ "shared.creating" | translate }}</span>
      </button>
      <button
        *ngIf="isEditing"
        class="btn btn--primary"
        (click)="onActionUpdateCategory()"
        [disabled]="saving || !category.title"
      >
        <span *ngIf="!saving">{{ "shared.continue" | translate }}</span>
        <span *ngIf="saving">{{ "shared.updating" | translate }}</span>
      </button>
    </div>
  </mat-dialog-actions>
</div>
